// src/confluence/blogpost/types.ts
var ConfluenceBlogpostAriResourceOwner = "confluence", ConfluenceBlogpostAriResourceType = "blogpost";

export {
  ConfluenceBlogpostAriResourceOwner,
  ConfluenceBlogpostAriResourceType
};
